import { EMPTY_STRING } from '../../../constants/common'

export const InfoItemsFields = {
  Category: 'category',
  Category2: 'category_2',
  Category3: 'category_3',
  DocumentTitle: 'document_title',
}

export const PROFILE_DATA_MOCK = {
  category: EMPTY_STRING,
  category_2:
    'Roof repair Premuim Roof repair Premuim Roof repair Premuim Roof repair Premuim',
  category_3: 'Roof repair Premuim',
  document_title: 'Invoice',
}

export const INFO_ITEM_TITLES = {
  [InfoItemsFields.Category]: 'Category',
  [InfoItemsFields.Category2]: 'Category 2',
  [InfoItemsFields.Category3]: 'Category 3',
  [InfoItemsFields.DocumentTitle]: 'Document Title',
}
